import { CLAY_ICONS } from '../../content/clayIconManifest';

const available = new Set(CLAY_ICONS);

/** Phosphor icon names used in content files -> clay icon file names. */
const FROM_PHOSPHOR = {
  Truck: 'truck',
  Package: 'parcel',
  Clock: 'clock',
  CheckCircle: 'delivered',
  Plugs: 'plug',
  CreditCard: 'card',
  Export: 'export',
  ClipboardText: 'clipboard',
  Target: 'cog',
  MapPin: 'pin',
  MapTrifold: 'binoculars',
  Path: 'line-chart',
  CurrencyInr: 'coin',
  HandCoins: 'cash',
  Vault: 'moneybag',
  Wallet: 'wallet',
  CalendarCheck: 'calendar',
  CalendarBlank: 'calendar',
  Fingerprint: 'user-check',
  ChartBar: 'chart',
  ChartLine: 'line-chart',
  ListChecks: 'checklist',
  Receipt: 'bill',
  FileText: 'file-check',
  ShieldCheck: 'shield',
  Users: 'team',
  ArrowsClockwise: 'sync',
  Database: 'folder',
  Desktop: 'laptop',
  DeviceMobile: 'phone',
  Phone: 'support',
  WhatsappLogo: 'chat',
  Envelope: 'mail',
  Buildings: 'building',
  GlobeHemisphereWest: 'globe',
  Gear: 'cog',
  Briefcase: 'briefcase',
  Lightning: 'bulb',
};

export function clayName(name) {
  if (!name) return null;
  const key = FROM_PHOSPHOR[name] || name;
  return available.has(key) ? key : null;
}

/** Renders the exported clay icon if it exists, otherwise `fallback` (or nothing). */
export default function ClayIcon({ name, size = 64, alt = '', fallback = null, className = '', style }) {
  const file = clayName(name);
  if (!file) return fallback;
  return (
    <img
      src={`/icons/clay/${size <= 72 ? 'sm/' : ''}${file}.webp`}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      draggable="false"
      className={`clay-icon ${className}`}
      style={{ width: size, height: size, ...style }}
    />
  );
}
